

























import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class DeactivatePicklrPopup extends Vue {
    @Prop() popupId!: string
    @Prop() action!: string
    @Prop() userId!: number
    $refs!: {
      closeDactivatePopupButton: HTMLFormElement
    }
    updateUserStatus () {
      this.$http
        .patch('users/' + this.userId + '/' + this.action)
        .then((response:any) => {
          this.$refs.closeDactivatePopupButton.click()
          this.$emit('sendActionUpdate')
        }, response => {
        })
    }
}
